import { connect } from 'react-redux';
import WalletPage from 'src/components/views/Wallet/WalletPage';
import { IStoreState } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isAgent, userInfo } }: IStoreState) => ({
  isAgent,
  userInfo,
});

export default connect(mapStateToProps)(WalletPage);



// WEBPACK FOOTER //
// ./src/containers/Wallet.ts